__turbopack_context__.v({
  "circle": "NumberAccordionButton-module-scss-module__CHTqOW__circle",
  "click-area": "NumberAccordionButton-module-scss-module__CHTqOW__click-area",
  "collapsed": "NumberAccordionButton-module-scss-module__CHTqOW__collapsed",
  "description": "NumberAccordionButton-module-scss-module__CHTqOW__description",
  "expanded": "NumberAccordionButton-module-scss-module__CHTqOW__expanded",
  "number": "NumberAccordionButton-module-scss-module__CHTqOW__number",
  "title": "NumberAccordionButton-module-scss-module__CHTqOW__title",
  "wrapper": "NumberAccordionButton-module-scss-module__CHTqOW__wrapper",
});
